<template>
  <div class="task-wrapper">
    <div class="task-time">
      任务有效期: {{ activity.startTime | formatDate }}—{{
        activity.endTime | formatDate
      }}
    </div>
    <task-item
      v-for="task in activity.taskList"
      :key="task.stageId"
      :task="task"
      :activity-id="activity.activityId"
      @recive="handleReciveTask"
    />
  </div>
</template>

<script>
import { dateTimeFormatter } from '@/utils/utils.js'
import TaskItem from './TaskItem.vue'
export default {
  components: {
    TaskItem
  },
  filters: {
    formatDate(value) {
      return dateTimeFormatter(value * 1000, 'YYYY.MM.DD')
    }
  },
  props: {
    activity: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleReciveTask(params) {
      this.$emit('recive', params)
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin bg-image($url) {
  background-image: url($url + '@2x.png');
  @media (-webkit-min-device-pixel-ratio: 3), (min-device-pixel-ratio: 3) {
    background-image: url($url + '@3x.png');
  }
}
.task-wrapper {
  padding: 0.26rem 0.3rem 0.3rem;
  margin-bottom: 0.24rem;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 2px 10px 0px rgba(85, 63, 32, 0.12);
  &:last-of-type {
    margin-bottom: 0;
  }
  .task-time {
    font-size: 0.24rem;
    line-height: 0.24rem;
    color: rgba(102, 102, 102, 0.8);
  }
}
</style>
